<template>
    <div class="xt-selector" @click="handleClick">
        <span class="xt-selector__font"><slot/></span>
        <img class="xt-selector__icon" src="../assets/kdj_bottom2x.png" width="12" height="12"/>
    </div>
</template>
<script>
export default {
  methods: {
    handleClick(event) {
      this.$emit('click', event)
    }
  }
}
</script>
<style lang="less" scoped>
.xt-selector{
    display: inline-block;
    cursor: pointer;
    text-align: center;
    padding: 0 3px 0 0;
    white-space: nowrap;
    align-items: center;
    .xt-selector__font{
        white-space: nowrap;
        display: inline-block;
    }
    .xt-selector__icon{
        margin-left: 5px;
        vertical-align: middle;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
    }
}
</style>